import { render, staticRenderFns } from "./Extra-error.vue?vue&type=template&id=2c564e2a"
import script from "./Extra-error.vue?vue&type=script&lang=js"
export * from "./Extra-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports